import { StorySlug } from "@/api/episodes-types";
import { CopyButton } from "@/components/ui/CopyButton";
import { prettyStoryType } from "@/utils/pretty";
import { Breadcrumbs, Typography } from "@mui/material";

type Props = {
  id: string;
  storyType?: StorySlug;
};

export function StoryConfigBreadcrumbs({ id, storyType }: Props) {
  return (
    <Breadcrumbs separator="·">
      <CopyButton text={id}>
        <Typography>{`Config ID: ${id}`}</Typography>
      </CopyButton>
      {storyType && (
        <Typography>{`Story type: ${prettyStoryType(storyType)}`}</Typography>
      )}
    </Breadcrumbs>
  );
}
